import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import Schedule from "./components/Schedule";
import Categories from "./components/Categories";
import Feed from "./components/Feed";
import Habits from "./components/Habits";
import Community from "./components/Community";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-900 text-background-50 shadow-lg transition-colors hover:bg-foreground-700"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotTopics />
        <Schedule />
        <Categories />
        <Feed />
        <Habits />
        <Community />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}